import { render } from "./ForeignTradeByCountriesTable.vue?vue&type=template&id=7681170e&scoped=true&ts=true"
import script from "./ForeignTradeByCountriesTable.vue?vue&type=script&lang=ts"
export * from "./ForeignTradeByCountriesTable.vue?vue&type=script&lang=ts"

import "./ForeignTradeByCountriesTable.vue?vue&type=style&index=0&id=7681170e&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7681170e"]])

export default __exports__